import { useEffect } from 'react'
import { parseTimeToDate, zeroPadding } from 'lib/helper'
import isAfter from 'date-fns/isAfter'
import isEqual from 'date-fns/isEqual'

const useForwardLastOrderTime = (
  orderStartTime: string,
  lastOrderTime: string,
  handleBusinessTimes: (time: string) => void
) => {
  return useEffect(() => {
    let startHour = parseInt(orderStartTime.split(':')[0], 10)
    let startTime = parseInt(orderStartTime.split(':')[1], 10) + 15
    if (startTime === 60) {
      startHour += 1
      startTime = 0
    }
    const time = `${zeroPadding(startHour)}:${zeroPadding(startTime)}`
    if (
      isAfter(parseTimeToDate(time), parseTimeToDate(lastOrderTime)) ||
      isEqual(parseTimeToDate(time), parseTimeToDate(lastOrderTime))
    ) {
      handleBusinessTimes(time)
    }
  }, [orderStartTime])
}

export default useForwardLastOrderTime
